import React, { useState } from "react";
import { Box, TextField, Button, Snackbar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MuiAlert from '@material-ui/lab/Alert';
import Verify from "../../../components/Verify/Verify.js";
import API from '../../../api/api';

const garageApi = new API();

const useStyles = makeStyles((theme) => ({
  successMessage: {
    padding: theme.spacing(2),
    backgroundColor: '#d4edda',
    color: '#155724',
    borderRadius: '8px',
    textAlign: 'center',
    marginTop: theme.spacing(2),
  },
}));

export default function ContactSection(props) {
  const classes = useStyles();
  const [verify, setVerify] = useState(false);
  const [sent, setSent] = useState(false);
  const [snackBar, setSnackBar] = useState(false);
  const [snackMessage, setSnackMessage] = useState('Senden fehlgeschlagen. Bitte später erneut versuchen.');
  const [contact, setContact] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [contactError, setContactError] = useState({
    name: false,
    email: false,
    message: false
  });

  function verifyDialog() {
    var update = {...contactError};
    if(contact.name === "") {
      update.name = true;
    }
    else if (contact.email === "") {
      update.email = true;
    }
    else if (contact.message === "") {
      update.message = true;
    }
    else {
      update.email = false;
      update.name = false;
      update.message = false;
      setVerify(true);
    }
    setContactError(update);
  }

  function closeVerifyDialog(result) {
    if(result) {
      garageApi.openEndpoints.formContact.create(contact)
        .then((response) => {
          if (!response || !response.data) {
            setSnackMessage('Senden fehlgeschlagen. Bitte später erneut versuchen.');
            setSnackBar(true);
            return;
          }
          setContact({
            name: "",
            email: "",
            message: ""
          });
          setSent(true);
          if (response.data.mail_sent === false) {
            setSnackMessage('Anfrage ist gespeichert, E-Mail-Benachrichtigung aktuell nicht möglich.');
            setSnackBar(true);
          }
        })
        .catch(() => {
          setSnackMessage('Senden fehlgeschlagen. Bitte später erneut versuchen.');
          setSnackBar(true);
        });
    }
    setVerify(false);
  }

  function changeContact(e, key) {
    var update = {...contact};
    update[key] = e.target.value;
    setContact(update);
  }

  function closeSnackBar (event, reason) {
    if (reason === 'clickaway') {
      return;
    }
    setSnackBar(false);
  }

  return (
    <section className="spg-section">
        <Snackbar open={snackBar} autoHideDuration={6000} onClose={closeSnackBar}>
          <MuiAlert elevation={6} variant="filled" onClose={closeSnackBar} severity="warning">
            {snackMessage}
          </MuiAlert>
        </Snackbar>
        <Verify open={verify} close={closeVerifyDialog}/>

        <div className="spg-kicker">Kontakt</div>
        <h2 className="spg-title">Schreiben Sie uns</h2>
        <div
          className="spg-lead"
          dangerouslySetInnerHTML={{__html: props.contactText}}
        />

          <form className="spg-form" onSubmit={(event) => { event.preventDefault(); verifyDialog(); }}>
            <div className="spg-form-grid">
              <TextField
                label="Name"
                fullWidth
                variant="outlined"
                error={contactError.name}
                value={contact.name}
                onChange={e => changeContact(e, 'name')}
              />
              <TextField
                label="E-Mail Adresse"
                fullWidth
                variant="outlined"
                error={contactError.email}
                type="email"
                value={contact.email}
                onChange={e => changeContact(e, 'email')}
              />
            </div>
            <TextField
              className="spg-contact-message"
              label="Nachricht"
              multiline
              variant="outlined"
              error={contactError.message}
              fullWidth
              rows={6}
              value={contact.message}
              onChange={e => changeContact(e, 'message')}
              style={{ marginTop: 16 }}
            />
            {sent ? (
              <Box className={classes.successMessage}>
                Ihre Kontakt Anfrage wurde versandt.
              </Box>
            ) : (
              <Button
                type="submit"
                variant="contained"
                className="spg-form-submit"
                size="large"
              >
                Senden
              </Button>
            )}
          </form>
    </section>
  );
}
